// extracted by mini-css-extract-plugin
export default {"list":"DataList_list__pvUCC","horizontal":"DataList_horizontal__1E8Ye","vertical":"DataList_vertical__ooBE4","rowList":"DataList_rowList__K3q8k","title":"DataList_title__gLrxx"};